import { DocumentationPage } from './_article.jsx';
export default function TroubleshootingPage({
  article,
  articles
}) {
  return <DocumentationPage article={article} articles={articles} />;
}